import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from '../form-field/form-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-form-checkbox',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatCheckboxModule, MatInputModule],
    templateUrl: './form-checkbox.component.html',
    styleUrl: './form-checkbox.component.scss',
})
export class FormCheckboxComponent extends FormInputComponent<boolean> {
    @Input() public override label = '';
}
